
export const buttonClass = {
    scogoOrange : 'bg-scogoOrange shadow-subBtnShadow border border-scogoOrange rounded-sm text-white text-base w-full m-auto pt-1 pb-1 ',
    scogoPrimary: 'bg-scogoprimary shadow-subBtnShadow border border-scogoprimary rounded-md text-white text-base w-full m-auto pt-1 pb-1 ',
    scogoTransparentBtn: "bg-scogoOrange text-sm text-white pl-3 pr-3 w-24s h-9 border border-scogoOrange rounded-md",
    ticketButton: 'border border-scogoprimary  rounded-md text-12F text-scogoprimary w-full m-auto py-1 px-1 hover:bg-scogoprimary hover:text-white',

}

export const textcss = {
    labelClass : "text-1rem mt-4 text-blurgray",
    inputClass : "w-full mt-2 text-base pb-2 ml-1",
    numberClass : "w-full h-full text-center",
    inputText : 'font-normal text-font11',
}


export const Icon = {
    HeadingIcon : "text-14F gap-0.5 grid text-center grid-cols-4 pt-4 justify-items-center m-auto"
}